import { useLocation } from 'wouter';

import useBrandFromLocation from '../../hooks/useBrandFromLocation';

import { LayoutContextProvider } from '../../contexts/LayoutContext';
import PageRoutes from '../PageRoutes';

export interface ReaderLayoutProps {
    presentation?: 'reader' | 'capture';
}

function ReaderLayout({ presentation = 'reader' }: ReaderLayoutProps) {
    const [location] = useLocation();
    const { brand: finalBrand } = useBrandFromLocation(location);
    return (
        <LayoutContextProvider brand={finalBrand} presentation={presentation}>
            <div data-theme="reader">
                <PageRoutes location={location} current adsDisabled={presentation === 'capture'} />
            </div>
        </LayoutContextProvider>
    );
}

export default ReaderLayout;
